<template>
  <div id="map"></div>
</template>

<script>
/* eslint-disable */

import './Control.FullScreen'
import './leaflet-providers'
import './locate-control'

export default {
  updated () {
    let tN1 = `<div id="bigFont">` + [this.$store.getters.schoolName] + `</div>`
  },
  mounted () {
    const pixel = this.$store.getters.pixel
    const latlng = this.$store.getters.latlng
    const lat = this.$store.getters.lat
    const lng = this.$store.getters.lng
    const zoom = this.$store.getters.zoom
    const type = this.$store.getters.type
    const seconds = this.$store.getters.seconds
    const name = this.$store.getters.schoolName
    const inverse = this.$store.getters.inverse
    const sTbM = this.$store.getters.baseOption
    let tN1 = `<div id="bigFont">` + [this.$store.getters.schoolName] + `</div>`

    var basemaps = r360.basemaps('N2T7JHHPOTJAWSFQ7YOMJYH')

    // var map = L.mapbox.map('map').setView(latlng, zoom)
    var map = L.map('map', {
      // fullscreenControl: true,
      zoomControl: false,
      // fullscreenControl: true,
      zoomControl: false,
      boxZoom: true
    }).setView(latlng, zoom)

    /*
    var marker = L.circleMarker(latlng, {
      'draggable': false,
      radius: 8,
      draggable: true,
      title: name,
      riseOnHover: true
    })
    map.addLayer(marker)

    var place1 = L.divIcon({
      html: tN1,
      className: 'place-div-icon',
      'draggable': true,
      iconSize: [300, 40],
      iconAnchor: [380, 270],
      popupAnchor: [0, 0]
    })
    var markerP1 = L.marker(latlng, {
      icon: place1
    })
    // map.addLayer(markerP1)
    */
    var myIcon = L.icon({
      iconUrl: '../../../static/img/ic_place_black_24dp_1x.png',
      iconSize: [0, 0],
      iconAnchor: [0, 0],
      popupAnchor: [0, 0],
      shadowUrl: '../../../static/img/marker-shadow.png',
      shadowSize: [0, 0],
      shadowAnchor: [22, 94]
    })
    var marker = L.marker((latlng), {
      icon: myIcon,
      draggable: true
    })
    map.addLayer(marker)

    var attribution = "ÖPNV Daten © <a href='https://www.vbb.de/de/index.html' target='_blank'>VBB</a>"
    L.mapbox.accessToken = 'pk.eyJ1IjoiYWx0b3Bob3RvIiwiYSI6ImNqNTg3YnQyeDE1bHMyd3RndGtmMzhyaDAifQ.sNFPJ1oHAeURc75FZtcR3A'

    // start leaflet providers
    var defaultLayer = L.mapbox.styleLayer('mapbox://styles/altophoto/cjamqc49sdvba2rl8fvle4rrk').addTo(map)
    var baseLayers = {
      // Techno
      'VT Winter Dev': defaultLayer,
      'VT Winter Gothic': L.mapbox.styleLayer('mapbox://styles/altophoto/cjain2glsa1fo2roavo9wowrw'),
      'VT Techno Gothic': L.mapbox.styleLayer('mapbox://styles/altophoto/cjaif6yjx8x2k2rkaayihh77s'),
      'Okemo': L.mapbox.styleLayer('mapbox://styles/altophoto/cjahchwrq8tdr2rpem2iwerrb'),
      'Decimal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wco3rhb2rsum3ay5y9g'),
      'Terminal': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6tqe2xzp2rmoqpt6rkl2'),
      // Vermont
      'VT Town Boundaries': L.mapbox.styleLayer('mapbox://styles/altophoto/cj84l42cs0sto2rkscn16kr7w'),
      'Red Pins': L.mapbox.styleLayer('mapbox://styles/altophoto/cj8a5r73162xj2sr3g8ajtn0v'),
      // Open Street Map
      'OpenStreetMap Default': L.tileLayer.provider('OpenStreetMap.Mapnik'),
      'OpenStreetMap German Style': L.tileLayer.provider('OpenStreetMap.DE'),
      'OpenStreetMap Black and White': L.tileLayer.provider('OpenStreetMap.BlackAndWhite'),
      'OpenStreetMap H.O.T.': L.tileLayer.provider('OpenStreetMap.HOT'),
      // Raster
      'Red Pins-Raster': L.tileLayer.provider('RedPins'),
      'VT Town Boundaries-Raster': L.tileLayer.provider('TownBoundaries'),
      'Town and Country-Raster': L.tileLayer.provider('TownAndCountry'),
      'Outdoors-Raster': L.tileLayer.provider('Outdoors'),
      'Raster Satellite': L.tileLayer.provider('Satellite'),
      'Satellite Streets': L.tileLayer.provider('SatelliteStreets'),
      // Slick
      'Hydda': L.tileLayer.provider('Hydda.Full'),
      'Basic Mapbox': L.tileLayer.provider('BasicMapbox'),
      'Basic Vector': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75t6cv53ha2smw8klm7h9k'),
      'Scenic': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6lvk2xv02rs66t75a3i1'),
      'Town and Country': L.mapbox.styleLayer('mapbox://styles/altophoto/cj89zxu1j5w742rk7t1x8vvvv'),
      'Standard': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw705a3qzw2rpjx6t079ds'),
      'North Star': L.mapbox.styleLayer ('mapbox://styles/altophoto/cjabw72f33rjf2spe4pnh4jbh'),
      // Funky
      'Toner': L.tileLayer.provider('Stamen.Toner'),
      'Watercolor': L.tileLayer.provider('Stamen.Watercolor'),
      'Vintage': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6nax3sgf2sntkany1okv'),
      'Ice Cream': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6pmb3rj62spea81rd8he'),
      'Desert planet': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw7f3m3sh82snteo04mp4o'),
      'whaam!': L.mapbox.styleLayer('mapbox://styles/altophoto/cjabw6wxi3qu52snwk1xqiv44'),
      // Outdoors
      'Terrain': L.tileLayer.provider('Stamen.Terrain'),
      '(vector) Satellite': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75y07p540k2spn6tfoh42k'),
      '(vector) Satellite Streets': L.mapbox.styleLayer('mapbox://styles/altophoto/cja7691sd53vs2so222ytty85'),
      'Outdoors': L.mapbox.styleLayer('mapbox://styles/altophoto/cja75wqs453kd2so2720o3bpe'),
      // Esri
      'Esri WorldStreetMap': L.tileLayer.provider('Esri.WorldStreetMap'),
      'Esri DeLorme': L.tileLayer.provider('Esri.DeLorme'),
      'Esri WorldTopoMap': L.tileLayer.provider('Esri.WorldTopoMap'),
      'Esri WorldImagery': L.tileLayer.provider('Esri.WorldImagery'),
      'Esri WorldTerrain': L.tileLayer.provider('Esri.WorldTerrain'),
      'Esri WorldShadedRelief': L.tileLayer.provider('Esri.WorldShadedRelief'),
      'Esri WorldPhysical': L.tileLayer.provider('Esri.WorldPhysical'),
      'Esri OceanBasemap': L.tileLayer.provider('Esri.OceanBasemap'),
      'Esri NatGeoWorldMap': L.tileLayer.provider('Esri.NatGeoWorldMap'),
      'Esri WorldGrayCanvas': L.tileLayer.provider('Esri.WorldGrayCanvas')
    }
    var overlayLayers = {
      'OpenSeaMap': L.tileLayer.provider('OpenSeaMap'),
      'OpenWeatherMap Clouds': L.tileLayer.provider('OpenWeatherMap.Clouds'),
      'OpenWeatherMap CloudsClassic': L.tileLayer.provider('OpenWeatherMap.CloudsClassic'),
      'OpenWeatherMap Precipitation': L.tileLayer.provider('OpenWeatherMap.Precipitation'),
      'OpenWeatherMap PrecipitationClassic': L.tileLayer.provider('OpenWeatherMap.PrecipitationClassic'),
      'OpenWeatherMap Rain': L.tileLayer.provider('OpenWeatherMap.Rain'),
      'OpenWeatherMap RainClassic': L.tileLayer.provider('OpenWeatherMap.RainClassic'),
      'OpenWeatherMap Pressure': L.tileLayer.provider('OpenWeatherMap.Pressure'),
      'OpenWeatherMap PressureContour': L.tileLayer.provider('OpenWeatherMap.PressureContour'),
      'OpenWeatherMap Wind': L.tileLayer.provider('OpenWeatherMap.Wind'),
      'OpenWeatherMap Temperature': L.tileLayer.provider('OpenWeatherMap.Temperature'),
      'OpenWeatherMap Snow': L.tileLayer.provider('OpenWeatherMap.Snow')
    }
    // resize layers control to fit into view.
    function resizeLayerControl () {
      var layerControlHeight = document.body.clientHeight - (10 + 50)
      var layerControl = document.getElementsByClassName('leaflet-control-layers-expanded')[0]
      // layerControl.style.overflowY = 'auto'
      // layerControl.style.maxHeight = layerControlHeight + 'px'
    }
    map.on('resize', resizeLayerControl)
    resizeLayerControl()
    // end leaflet providers
    // L.control.locate().addTo(map);
    L.control.zoom({ position: 'bottomright' }).addTo(map)

    var opacity = 100
    var polygonLayer = r360.leafletPolygonLayer({ inverse: inverse })
    map.addLayer(polygonLayer)

    var travelOptions = r360.travelOptions()
    travelOptions.setServiceKey('N2T7JHHPOTJAWSFQ7YOMJYH')
    travelOptions.setServiceUrl('https://service.route360.net/na_northeast/')
    travelOptions.addSource(marker)
    travelOptions.setTravelTimes(seconds)
    travelOptions.setTravelType(type)
    if (inverse === true) {
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel)
        polygonLayer.setColors([
          { 'time': seconds[0], 'opacity': opacity / 100 },
          { 'time': seconds[1], 'opacity': (opacity / 100) - 0.1 },
          { 'time': seconds[2], 'opacity': (opacity / 100) - 0.2 }
        ])
        polygonLayer.clearAndAddLayers(polygons, true)
      })
    } else {
      r360.PolygonService.getTravelTimePolygons(travelOptions, function (polygons) {
        polygonLayer.setStrokeWidth(pixel)
        polygonLayer.clearAndAddLayers(polygons, true)
      })
    }

    L.control.layers(baseLayers, basemaps, {collapsed: true}).addTo(map)
    // L.control.layers(basemaps).addTo(map)
    // L.control.layers(baseLayers, {collapsed: false}).addTo(map)
    L.control.scale().addTo(map)
    // L.control.zoom().addTo(map)
  },
  created () {
    const pixel = this.$store.getters.pixel
    const latlng = this.$store.getters.latlng
    const zoom = this.$store.getters.zoom
    const type = this.$store.getters.type
    const seconds = this.$store.getters.seconds
    const name = this.$store.getters.schoolName
    const sTbM = this.$store.getters.baseOption
  }
}
</script>

<style scoped>
#bigFont {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: white;
}
.btn-title {
  background: repeating-linear-gradient(10deg, #d3d3d3, #7fa995 1px, #96c79d 1px, #b7ce98 1px, #e2ba8b 1px, #dfa38d 1px, #cc8f91 1px);
}
#map{position: absolute;width:98%;right:1%;left:1%; z-index:1; top:8%;height:91%;bottom: 1%;background:#F0E9D8;}

.leaflet-div-icon{
  font-size: 14px;
  padding-top: 25px;
  padding-bottom: 10px;
  padding-left: 4px;
  padding-right: 0px;
  border-radius: 50%;
};
.place-div-icon{
  border: 1px solid black;
  box-sizing: border-box;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 0px;
  padding-right: 0px;
  border-radius: 50%;
};
.marker{border:none;cursor:pointer;height:56px;width:56px;background-image:url(../../../static/img/ic_place_black_24dp_1x.png);background-color:rgba(0,0,0,0)}
.leaflet-control-layers-toggle{background-image:url(../../../static/img/layers.png);width:36px;height:36px}.leaflet-container.dark .map-tooltip .close .leaflet-control-attribution:after .leaflet-control-layers-toggle .leaflet-control-zoom-in .leaflet-control-zoom-out .leaflet-popup-close-button .map-tooltip .close .mapbox-icon{opacity:.75;background-image:url(../../../static/img/ic_place_black_24dp_2x.png);background-repeat:no-repeat;background-size:26px 260px}
.leaflet-container.dark .leaflet-control-attribution:after .leaflet-container.dark .leaflet-control-layers-toggle .leaflet-container.dark .leaflet-control-zoom-in .leaflet-container.dark .leaflet-control-zoom-out .leaflet-container.dark .mapbox-icon .mapbox-button-icon:before{opacity:1;background-image:url(../../../static/img/ic_place_black_24dp_2x.png);background-size:26px 260px}retina .leaflet-control-layers-toggle{background-image:url(../../../static/img/layers-2x.png);background-size:26px 26px}
.leaflet-default-icon-path{background-image:url(../../../static/img/ic_place_black_24dp_1x.png)}
.leaflet-container.dark .map-tooltip .close .leaflet-control-attribution:after .leaflet-control-layers-toggle .leaflet-control-zoom-in .leaflet-control-zoom-out .leaflet-popup-close-button .map-tooltip .close .mapbox-icon{opacity:.75;background-image:url(../../../static/img/ic_place_black_24dp_2x.png);background-repeat:no-repeat;background-size:26px 260px}
.leaflet-container.dark .leaflet-control-attribution:after .leaflet-container.dark .leaflet-control-layers-toggle .leaflet-container.dark .leaflet-control-zoom-in .leaflet-container.dark .leaflet-control-zoom-out .leaflet-container.dark .mapbox-icon .mapbox-button-icon:before{opacity:1;background-image:url(../../../static/img/marker-icon-2x.png);background-size:26px 260px}


.leaflet-default-icon-path {
  background-image:url(../../../static/img/ic_place_black_24dp_1x.png)
  }

.fullscreen-icon { background-image: url(../../../static/img/icon-fullscreen.png); }
.leaflet-retina .fullscreen-icon { background-image: url(../../../static/img/icon-fullscreen-2x.png); background-size: 26px 26px; }
/* one selector per rule as explained here : http://www.sitepoint.com/html5-full-screen-api/ */
.leaflet-container:-webkit-full-screen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-container:-ms-fullscreen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-container:full-screen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-container:fullscreen { width: 100% !important; height: 100% !important; z-index: 99999; }
.leaflet-pseudo-fullscreen { position: fixed !important; width: 100% !important; height: 100% !important; top: 0px !important; left: 0px !important; z-index: 99999; }

.leaflet-container .leaflet-control-scale{font-size:11px}
.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;font-size:11px;white-space:nowrap;overflow:hidden;-moz-box-sizing:content-box;box-sizing:content-box;background:#fff;background:rgba(255,255,255,0.5)}

/* Compatible with Leaflet 0.7 */
.leaflet-control-locate a {
  font-size: 1.4em;
  color: #444;
  cursor: pointer;
}
.leaflet-control-locate.active a {
  color: #2074B6;
}
.leaflet-control-locate.active.following a {
  color: #FC8428;
}
/* Compatible with Leaflet 0.7 */
.leaflet-control-locate a {
  font-size: 1.4em;
  color: #444;
  cursor: pointer;
}
.leaflet-control-locate.active a {
  color: #2074B6;
}
.leaflet-control-locate.active.following a {
  color: #FC8428;
}

/* Mapbox specific adjustments */
.leaflet-control-locate a {
  padding: 3px 0 0 8px;
}
.leaflet-control-locate.requesting a {
  padding: 3px 0 0 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/toolBox/mapBoard.vue